import { addBreadcrumb } from '@sentry/react';
import { type Metric, onCLS, onINP, onLCP } from 'web-vitals';

const report = (metric: Metric): void => {
  addBreadcrumb({ category: 'web-vital', message: metric.name, level: 'info', data: { value: Math.round(metric.value), rating: metric.rating } });
  if (import.meta.env.DEV) console.debug(`[web-vitals] ${metric.name}=${Math.round(metric.value)} (${metric.rating})`);
};

/** Core Web Vitals as RUM — LCP (load), INP (responsiveness), CLS (stability).
 *  Fed to Sentry as breadcrumbs (and console in dev); a no-op if Sentry is off. */
export function reportWebVitals(): void {
  onCLS(report);
  onINP(report);
  onLCP(report);
}
